<template>
  <div class="comm_strategy">
    <el-tabs v-model="activeName">
      <el-tab-pane label="创建流程" name="first"></el-tab-pane>
      <el-tab-pane label="结果报表" name="second"></el-tab-pane>
    </el-tabs>
    <!-- 创建页面 -->
    <div class="strategy_tab_create" v-show="activeName == 'first'">
      <!-- 回显填充 -->

      <div style="text-align:right;margin-bottom:15px;">
        <span>{{ $t('title.environment') }}:</span>
        <el-select value-key="name" v-model="environment" placeholder="请选择环境" style="margin:0 20px">
          <el-option
            v-for="item in environmentList"
            :key="item.name"
            :label="item.name"
            :value="item"
          ></el-option>
        </el-select>
        <el-button type="success" @click="dialogVisible = true">{{ $t('title.Test_case') }}</el-button>
      </div>

      <!-- 创建芯品芯城 -->
      <div class="strategy_create scroll_strategy_create">
        <div class="strategy_create_header scroll-header">
          <!-- <span class="create_item" style="width:150px">创建芯城手机</span> -->
          <span class="create_item" style="width:150px">芯城名</span>
          <span class="create_item">xto名字</span>
          <span class="create_item">兑换xto总量</span>
          <span class="create_item">兑换1个xto所需积分</span>
          <span class="create_item">推广xto总量</span>
          <span class="create_item">推广孩子XTO数量</span>
          <!-- <span class="create_item">芯品分红比例</span> -->
          <span class="create_item">芯城分红比</span>
          <span class="create_item">管理xto总量</span>
          <span class="create_item">消费+推广n</span>
          <span class="create_item">管理发放m</span>
          <span class="create_item">股权董事长</span>
          <span style="width:255px;" class="create_item">股权分配</span>
          <!-- <span class="create_item">一级分佣比例</span>
          <span class="create_item">二级分佣比例</span>-->
          <el-button type="primary" @click="addReg(0)">{{ $t('title.Add_to') }}</el-button>
        </div>
        <div v-for="item in xinChengs" :key="item.id">
          <div class="strategy_create_body">
            <div class="create_body_item scroll_body_item">
              <!-- <div style="width:150px" class="scroll_col">
                <input class="el_input" v-model="item.userPhone" placeholder="创建芯城手机" />
              </div>-->
              <div style="width:150px" class="scroll_col">
                <input class="el_input" v-model="item.projectName" placeholder="芯城名" />
              </div>
              <div style="width: 48px;" class="scroll_col">
                <input class="el_input" v-model="item.xtoName" placeholder="xto名字" />
              </div>
              <div style="width: 76px;" class="scroll_col">
                <input class="el_input" v-model="item.xtoExchangeMaxCount" type="number" />
              </div>
              <div style="width: 123px;" class="scroll_col">
                <input class="el_input" v-model="item.xtoExchangeRoundPoint" type="number" />
              </div>
              <div style="width: 76px;" class="scroll_col">
                <input class="el_input" v-model="item.xtoInviteMaxCount" type="number" />
              </div>
              <div style="width: 115px;" class="scroll_col">
                <input class="el_input" v-model="item.xtoInviteRoundCount" type="number" />
              </div>
              <!-- <div style="width: 84px;" class="scroll_col">
                <input class="el_input" v-model="item.profitBrandPercent" type="number" />
              </div>-->
              <div style="width: 70px;" class="scroll_col">
                <input class="el_input" v-model="item.profitMallPercent" type="number" />
              </div>
              <div style="width: 75px;" class="scroll_col">
                <input class="el_input" v-model="item.xtoManageMaxCount" type="number" />
              </div>
              <div style="width: 75px;" class="scroll_col">
                <input class="el_input" v-model="item.xtoManageRoundCount" type="number" />
              </div>
              <!-- <div style="width: 84px;" class="scroll_col">
                <input class="el_input" v-model="item.commission1stPercent" type="number" />
              </div>
              <div style="width: 84px;" class="scroll_col">
                <input class="el_input" v-model="item.commission2ndPercent" type="number" />
              </div>-->
              <div style="width: 65px;" class="scroll_col">
                <input class="el_input" v-model="item.xtoManageSendCount" type="number" />
              </div>
              <div style="width: 70px;" class="scroll_col">
                <input class="el_input" v-model="item.managerUserPhone" placeholder="手机号" />
              </div>
              <div style="width: 255px;" class="scroll_col">
                <input class="el_input" v-model="item.managerUserList" />
              </div>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="deleteReg(item.id, xinChengs, 'xinChengs')"
              ></el-button>
            </div>
            <div
              class="strategy_create_header scroll-header scroll_body_child_header"
              style="margin-left:50px;"
            >
              <!-- <span class="create_item">创建芯品手机</span> -->
              <span style="width:100px;" class="create_item">芯品名</span>
              <span class="create_item">xto名字</span>
              <span class="create_item">兑换xto总量</span>
              <span class="create_item">兑换1个xto所需积分</span>
              <span class="create_item">推广xto总量</span>
              <span class="create_item">推广孩子XTO数量</span>
              <span class="create_item">芯品分红比</span>
              <!-- <span class="create_item">芯城分红比例</span> -->
              <span class="create_item">管理xto总量</span>
              <span class="create_item">消费+推广n</span>
              <span class="create_item">管理发放m</span>
              <span class="create_item">股权董事长</span>
              <span style="width:255px;" class="create_item">股权分配</span>
              <el-button type="primary" @click="addReg(1, item.id)">{{ $t('title.Add_to') }}</el-button>
            </div>
            <div
              class="create_body_item scroll_body_item"
              v-for="itemChild in item.xinPings"
              :key="itemChild.id"
              style="margin-left:50px;"
            >
              <!-- <div style="width: 84px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.userPhone" placeholder="绑定用户" />
              </div>-->
              <div style="width:100px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.projectName" placeholder="芯品名" />
              </div>
              <div style="width: 48px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.xtoName" placeholder="xto名字" />
              </div>
              <div style="width: 76px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.xtoExchangeMaxCount" type="number" />
              </div>
              <div style="width: 123px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.xtoExchangeRoundPoint" type="number" />
              </div>
              <div style="width: 76px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.xtoInviteMaxCount" type="number" />
              </div>
              <div style="width: 115px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.xtoInviteRoundCount" type="number" />
              </div>
              <div style="width: 70px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.profitBrandPercent" type="number" />
              </div>
              <!-- <div style="width: 84px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.profitMallPercent" type="number" />
              </div>-->
              <div style="width: 75px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.xtoManageMaxCount" type="number" />
              </div>
              <div style="width: 75px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.xtoManageRoundCount" type="number" />
              </div>
              <div style="width: 65px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.xtoManageSendCount" type="number" />
              </div>
              <div style="width: 70px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.managerUserPhone" placeholder="手机号" />
              </div>
              <div style="width: 255px;" class="scroll_col">
                <input class="el_input" v-model="itemChild.managerUserList" />
              </div>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="deleteReg(item.id, xinChengs, 'xinChengs', 'id', itemChild.id)"
              ></el-button>
            </div>
          </div>
        </div>
        <div style="text-align:right;">
          <el-button :disabled="btnDisabled" type="success" @click="createMall">
            创建芯城芯品
            <span v-if="btnDisabled">{{time}}秒</span>
          </el-button>
        </div>
      </div>
      <!-- 初始化手机号 -->
      <div class="strategy_create">
        <div class="strategy_create_header">
          <el-row :gutter="10">
            <el-col :span="3" class="create_item">手机号</el-col>
            <el-col :span="3" class="create_item">上级手机号</el-col>
            <el-col :span="3" class="create_item">芯城名</el-col>
            <el-col :span="3" class="create_item">注册商城</el-col>
            <el-col :span="3" class="create_item">注册芯客</el-col>
            <el-col :span="8">
              <el-button type="primary" @click="addReg(2)">{{ $t('title.Add_to') }}</el-button>
            </el-col>
          </el-row>
        </div>
        <div class="strategy_create_body">
          <div class="create_body_item" v-for="item in regData" :key="item.id">
            <el-row :gutter="10">
              <el-col :span="3" class="create_item">
                <el-input v-model="item.phone" placeholder="请输入手机号"></el-input>
              </el-col>
              <el-col :span="3" class="create_item">
                <el-input v-model="item.superiorPhone" placeholder="请输入上级手机号"></el-input>
              </el-col>
              <el-col :span="3" class="create_item">
                <el-input v-model="item.projectName" placeholder="请输入芯城名"></el-input>
              </el-col>
              <el-col :span="3" class="create_item">
                <el-checkbox v-model="item.mall"></el-checkbox>
              </el-col>
              <el-col :span="3" class="create_item">
                <el-checkbox v-model="item.xk"></el-checkbox>
              </el-col>
              <el-col :span="1" class="create_item">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="deleteReg(item.id, regData, 'regData')"
                ></el-button>
              </el-col>
            </el-row>
          </div>
          <div style="text-align:right">
            <el-button :disabled="btnDisabled" type="success" @click="initializePhone">
              初始化手机号及上下级
              <span v-if="btnDisabled">{{time}}秒</span>
            </el-button>
          </div>
        </div>
      </div>
      <!-- 创建规格 -->
      <div class="strategy_create">
        <div class="strategy_create_header">
          <el-row>
            <el-col :span="24" style="color:red">如果不设置购买手机号，系统自动随机购买</el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="1" class="create_item">标识</el-col>
            <el-col :span="2" class="create_item">芯城名(必填)</el-col>
            <el-col :span="2" class="create_item">芯品名</el-col>
            <!-- <el-col :span="2" class="create_item">商品名</el-col> -->
            <el-col :span="2" class="create_item">商品规格名称</el-col>
            <el-col :span="1" class="create_item">库存数</el-col>
            <el-col :span="2" class="create_item">供货价</el-col>
            <el-col :span="2" class="create_item">零售价</el-col>
            <el-col :span="2" class="create_item">自购返利</el-col>
            <el-col :span="2" class="create_item">分享返利</el-col>
            <el-col :span="2" class="create_item">换货时间(秒)</el-col>
            <el-col :span="2" class="create_item">退货时间(秒)</el-col>
            <el-col :span="2" class="create_item">登录数据</el-col>
            <el-col :span="3">
              <el-button type="primary" @click="addReg(3)">{{ $t('title.Add_to') }}</el-button>
            </el-col>
          </el-row>
        </div>
        <div class="strategy_create_body">
          <div class="create_body_item" v-for="item in sizeData" :key="item.id">
            <el-row :gutter="10">
              <el-col :span="1" class="create_item">
                <el-checkbox v-model="item.pingtaiState"></el-checkbox>
              </el-col>
              <el-col :span="2" class="create_item">
                <el-input v-model="item.xkMallName" placeholder="芯城名"></el-input>
              </el-col>
              <el-col :span="2" class="create_item">
                <el-input v-model="item.xkProjectName" placeholder="芯品名"></el-input>
              </el-col>
              <!-- <el-col :span="2" class="create_item">
                <el-input v-model="item.productName" placeholder="商品名"></el-input>
              </el-col>-->
              <el-col :span="2" class="create_item">
                <el-input v-model="item.sizeName" placeholder="商品规格名称"></el-input>
              </el-col>
              <el-col :span="1" class="create_item">
                <input class="el_input" type="number" v-model="item.stockCount" />
              </el-col>
              <el-col :span="2" class="create_item">
                <input class="el_input" type="number" v-model="item.supplyPrice" />
              </el-col>
              <el-col :span="2" class="create_item">
                <input class="el_input" type="number" v-model="item.retailPrice" />
              </el-col>
              <el-col :span="2" class="create_item">
                <el-input type="number" v-model="item.automaticRebate"></el-input>
              </el-col>
              <el-col :span="2" class="create_item">
                <el-input type="number" v-model="item.shareRebate"></el-input>
              </el-col>
              <el-col :span="2" class="create_item">
                <el-input type="number" v-model="item.exchangeTime"></el-input>
              </el-col>
              <el-col :span="2" class="create_item">
                <el-input type="number" v-model="item.returnTime"></el-input>
              </el-col>
               <el-col :span="2" class="create_item">
                <el-input v-model="item.loginStr"></el-input>
              </el-col>
              <el-col :span="2" class="create_item">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="deleteReg(item.id, sizeData, 'sizeData')"
                ></el-button>
              </el-col>
            </el-row>
            <el-row style="margin-top:20px;" :gutter="10">
              <el-col :span="4" class="create_item">购买手机号</el-col>
              <el-col :span="4" class="create_item">购买数量</el-col>
              <el-col :span="4" class="create_item">
                <el-button type="primary" @click="addReg(4, item.id)">{{ $t('title.Add_to') }}</el-button>
              </el-col>
            </el-row>
            <el-row
              style="margin-top:20px;"
              :gutter="10"
              v-for="itemPhone in item.phone"
              :key="itemPhone.id"
            >
              <el-col :span="4" class="create_item">
                <el-input v-model="itemPhone.phone" placeholder="请输入购买手机号"></el-input>
              </el-col>
              <el-col :span="4" class="create_item">
                <el-input type="number" v-model="itemPhone.num"></el-input>
              </el-col>
              <el-col :span="4" class="create_item">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="deleteReg(item.id, sizeData, 'sizeData', itemPhone.id)"
                ></el-button>
              </el-col>
            </el-row>
          </div>
          <div style="text-align:right;">
            <el-button :disabled="btnDisabled" type="success" @click="createSize">
              创建规格并下单
              <span v-if="btnDisabled">{{time}}秒</span>
            </el-button>
          </div>
        </div>
      </div>
      <!-- 发起策略 -->
      <div class="strategy_create" style="border-bottom:none;padding-bottom:0;">
        <div class="strategy_create_header">
          <el-row :gutter="10">
            <el-col :span="10" class="create_item" style="text-align:right;">
              <el-input v-model="remark" :placeholder="this.$t('title.Please_enter_a_note')"></el-input>
            </el-col>
            <el-col :span="14" class="create_item" style="text-align:right;">
              <el-button  type="danger" @click="saveCase">
               {{ $t('title.Save_the_use_case') }}
                
              </el-button>
              <el-button :disabled="btnDisabled" type="danger" @click="sendStrategy">
                发起策略
                <span v-if="btnDisabled">{{time}}秒</span>
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="strategy_create_body strategy_log_body">
          <div class="strategy_log" id="strategy">
            <template v-for="item in logMessageArr">
              {{item}}
              <br />
            </template>
          </div>
        </div>
      </div>
      <!-- 手机号验证 -->
      <el-dialog :title="this.$t('title.hint')" :visible.sync="warningVisible" width="30%" :before-close="closeWarning">
        <h4>以下手机号在初始化手机号中未填写!</h4>
        <p style="padding-left:10px;" v-for="(item, index) in warningData" :key="index">{{item}}</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeWarning">{{ $t('title.Cancel') }}</el-button>
          <el-button type="primary" @click="sureSend">{{ $t('title.Sure') }}</el-button>
        </span>
      </el-dialog>
    </div>
    <ResultReport :activeName="activeName" :environment="environment" />
    <TestCase
      @handleClose="handleClose"
      :environment="environment"
      :PropdialogVisible="dialogVisible"
      @echoData="echoData"
    />
  </div>
</template>
<script>
import _ from "lodash";
import {
  getStrategyShow,
  getStrategyView,
  exportReport,
  saveExample,
} from "@/api/interface";
import ResultReport from "./resultReport";
import TestCase from "./components/TestCase";
export default {
  components: {
    ResultReport,
    TestCase
  },
  data() {
    return {
      activeName: "first",
      regData: [
        {
          id: 0,
          phone: "",
          superiorPhone: "",
          projectName: "",
          mall: false,
          xk: false
        }
      ],
      xinChengs: [
        {
          id: 0,
          userPhone: "13592589592",
          projectName: "测试城",
          xtoName: "测试",
          xtoExchangeMaxCount: 1000,
          xtoExchangeRoundPoint: 50,
          xtoInviteMaxCount: 1000,
          xtoInviteRoundCount: 2,
          profitBrandPercent: 0.5,
          profitMallPercent: 0.5,
          xtoManageMaxCount: 1000,
          xtoManageRoundCount: 1,
          commission1stPercent: 0.5,
          commission2ndPercent: 0.5,
          xtoManageSendCount: 0.5,
          managerUserList:
            '[{"phone":"","scale":1},{"phone":"","scale":2},{"phone":"","scale":4}]',
          managerUserPhone: "",
          xinPings: [
            {
              id: 0,
              userPhone: "13592589592",
              projectName: "测试品",
              xtoName: "测试",
              xtoExchangeMaxCount: 1000,
              xtoExchangeRoundPoint: 50,
              xtoInviteMaxCount: 1000,
              xtoInviteRoundCount: 2,
              profitBrandPercent: 0.5,
              profitMallPercent: 0.5,
              xtoManageMaxCount: 1000,
              xtoManageRoundCount: 1,
              xtoManageSendCount: 0.5,
              managerUserList:
                '[{"phone":"","scale":1},{"phone":"","scale":2},{"phone":"","scale":4}]',
              managerUserPhone: ""
            }
          ]
        }
      ],
      sizeData: [
        {
          id: 0,
          pingtaiState: false,
          xkMallName: "xcTest",
          xkProjectName: "xpTest",
          productName: "奥利给",
          sizeName: "222",
          stockCount: 1,
          supplyPrice: 1,
          retailPrice: 1,
          marketingAmounts: 100,
          automaticRebate: 1,
          shareRebate: 1,
          exchangeTime: 0,
          returnTime: 0,
          loginStr: '',
          phone: [
            {
              id: 0,
              phone: "13592589457",
              num: 1
            }
          ]
        }
      ],
      logMessage: [], //日志
      logMessageArr: [], //展示日志
      socket: null,
      // uri: "ws://192.168.99.117:8010",
      //uri: "ws://43.247.184.53:9010/strategy",
      ws: null,
      key: "",
      btnDisabled: false,
      dialogVisible: false,
      warningVisible: false,
      warningData: [],
      time: 180,
      timeOut: null,
      remark: "",
      environmentList: [
        {
          name: "测试",
          http: "http://43.247.184.53:8410/strategy-test",
          socket: "ws://43.247.184.53:9010/strategy-test"
        },
        {
          name: "预发布",
          http: "http://43.247.184.53:8410/strategy_pre",
          socket: "ws://43.247.184.53:9010/strategy_pre"
        },
        {
          name: "宇豪本地",
          http: "http://192.168.0.124:9005",
          socket: "ws://192.168.0.124:8010"
        }
      ],
      environment: {
        name: "测试",
        http: "http://43.247.184.53:8410/strategy-test",
        socket: "ws://43.247.184.53:9010/strategy-test"
      }
    };
  },
  created() {
    //初始化websocket
    this.Connect();
  },
  watch: {
    environment(val) {
      this.Connect();
    }
  },
  methods: {
    //type对应的模块 id添加对应二级时
    addReg(type, id) {
      if (type == 0) {
        //添加芯城
        this.xinChengs.push({
          id: Date.now(),
          userPhone: "13592589592",
          projectName: "",
          xtoName: "",
          xtoExchangeMaxCount: 1,
          xtoExchangeRoundPoint: 1,
          xtoInviteMaxCount: 1,
          xtoInviteRoundCount: 1,
          profitBrandPercent: 1,
          profitMallPercent: 1,
          xtoManageMaxCount: 1,
          xtoManageRoundCount: 1,
          commission1stPercent: 1,
          commission2ndPercent: 1,
          xtoManageSendCount: 1,
          managerUserList: "",
          managerUserPhone: "",
          xinPings: [
            {
              id: 0,
              userPhone: "13592589592",
              projectName: "",
              xtoName: "",
              xtoExchangeMaxCount: 1,
              xtoExchangeRoundPoint: 1,
              xtoInviteMaxCount: 1,
              xtoInviteRoundCount: 1,
              profitBrandPercent: 1,
              profitMallPercent: 1,
              xtoManageMaxCount: 1,
              xtoManageRoundCount: 1,
              xtoManageSendCount: 1,
              managerUserList: "",
              managerUserPhone: ""
            }
          ]
        });
      } else if (type == 1) {
        //添加芯品
        console.log(1111);
        this.xinChengs.forEach(val => {
          if (val.id == id) {
            val.xinPings.push({
              id: Date.now(),
              userPhone: "",
              projectName: "",
              xtoName: "",
              xtoExchangeMaxCount: 1,
              xtoExchangeRoundPoint: 1,
              xtoInviteMaxCount: 1,
              xtoInviteRoundCount: 1,
              profitBrandPercent: 1,
              profitMallPercent: 1,
              xtoManageMaxCount: 1,
              xtoManageRoundCount: 1,
              xtoManageSendCount: 1,
              managerUserList: "",
              managerUserPhone: ""
            });
          }
        });
      } else if (type == 2) {
        //添加初始化手机号
        this.regData.push({
          id: Date.now(),
          phone: "",
          superiorPhone: "",
          mall: false,
          xk: false
        });
      } else if (type == 3) {
        //添加规格
        this.sizeData.push({
          id: Date.now(),
          pingtaiState: false,
          xkMallName: "",
          xkProjectName: "",
          productName: "奥利给",
          sizeName: "",
          stockCount: 1,
          supplyPrice: 1,
          retailPrice: 1,
          marketingAmounts: 100,
          automaticRebate: 1,
          shareRebate: 1,
          exchangeTime: 0,
          returnTime: 0,
          loginStr: '',
          phone: [
            {
              id: 0,
              num: ""
            }
          ]
        });
      } else if (type == 4) {
        //添加手机号
        this.sizeData.forEach(val => {
          if (val.id == id) {
            val.phone.push({
              id: Date.now(),
              value: ""
            });
          }
        });
      }
    },
    //二级删除时给一个默认值进行判断 phoneId（创建规格二级 购买手机号）itemChildId（创建芯品 二级）
    deleteReg(id, data, name, phoneId = "id", itemChildId = "id") {
      //id == id  data == 当前数据 数据名字
      //phoneId 在二级数据中  == 二级id
      //itemChildId 在二级数据中  == 二级id
      //删除购买手机号
      if (phoneId != "id") {
        this.sizeData.forEach(val => {
          if (val.id == id) {
            val.phone = val.phone.filter(v => v.id !== phoneId);
          }
        });
        //删除芯品
      } else if (itemChildId != "id") {
        this.xinChengs.forEach(val => {
          if (val.id == id) {
            val.xinPings = val.xinPings.filter(v => v.id !== itemChildId);
          }
        });
      } else {
        this[name] = data.filter(v => v.id !== id);
      }
    },
    //数据组装
    setData() {
      const sizeData = this.sizeData.map(v => ({
        ...v,
        pingtaiState: v.pingtaiState == false ? 0 : 1,
        supplyPrice: v.supplyPrice * 100,
        retailPrice: v.retailPrice * 100,
        automaticRebate: v.automaticRebate * 100,
        shareRebate: v.shareRebate * 100
      }));
      const initUser = this.regData.map(v => ({
        ...v,
        xk: v.xk == false ? 0 : 1,
        mall: v.mall == false ? 0 : 1
      }));
      return { sizeData, initUser }
    },
    //发起策略
    sendStrategy() {
      //禁用按钮
      this.btnDisabled = true;
      //2分钟倒计时
      this.buttonActive();
      //发起策略时前三次的数据再发送一遍
      const sizeDataCopy = {
        code: 4,
        data: {
          createXinCheng: this.xinChengs,
          remark: this.remark,
          ...this.setData()
        }
      };
      this.socket.send(JSON.stringify(sizeDataCopy));
    },
    //创建芯城芯品
    createMall() {
      //禁用按钮
      this.btnDisabled = true;
      //2分钟倒计时
      this.buttonActive();
      const data = { code: 2, data: { xinChengs: this.xinChengs } };
      this.socket.send(JSON.stringify(data));
    },
    //初始化手机号上下级
    initializePhone() {
      this.btnDisabled = true;
      //2分钟倒计时
      this.buttonActive();
      //Boolean转为数字
      const regData = this.regData.map(v => ({
        ...v,
        xk: v.xk == false ? 0 : 1,
        mall: v.mall == false ? 0 : 1
      }));
      const data = { code: 1, data: { regData } };
      this.socket.send(JSON.stringify(data));
    },
    //创建规格
    createSize() {
      this.btnDisabled = true;
      //创建规格校验
      let reg = 0;
      this.sizeData.forEach(v => {
        for (let item in v) {
          if (
            item != "phone" &&
            item != "id" &&
            item != "pingtaiState" &&
            item != "exchangeTime" &&
            item != "returnTime" &&
            item != "xkProjectName" &&
            item != "loginStr"
          ) {
            if (v[item] === "") {
              reg = 1;
              return;
            }
          }
          if (item == "phone") {
            for (let key of v[item]) {
              if (key.num <= 0) {
                reg = 2;
                return;
              }
            }
          }
        }
      });
      if (reg == 1) {
        this.$message.error("规格不能为空!");
      } else if (reg == 2) {
        this.$message.error("购买手机号数量不能小于1!");
      } else {
        this.phoneVerification();
      }
    },
    //手机号校验
    phoneVerification() {
      const sizePhone = [];
      this.sizeData.map(v => {
        v.phone.map(item => {
          sizePhone.push(item);
        });
      });
      const regData = this.regData.map(v => v.phone);
      for (let item of sizePhone) {
        if (!regData.includes(item.phone)) {
          this.warningData.push(item.phone);
        }
      }
      if (this.warningData.length != 0) {
        this.warningVisible = true;
      } else {
        this.sureSend();
      }
    },
    sureSend() {
      this.warningVisible = false;
      this.warningData = [];
      //2分钟倒计时
      this.buttonActive();
      //Boolean转为数字
      const sizeData = this.sizeData.map(v => ({
        ...v,
        pingtaiState: v.pingtaiState == false ? 0 : 1,
        supplyPrice: v.supplyPrice * 100,
        retailPrice: v.retailPrice * 100,
        automaticRebate: v.automaticRebate * 100,
        shareRebate: v.shareRebate * 100
      }));
      const data = { code: 3, data: { sizeData } };
      console.log(data, 9999999);
      this.socket.send(JSON.stringify(data));
    },
    closeWarning() {
      this.warningVisible = false;
      this.btnDisabled = false;
      this.warningData = [];
    },
    Connect() {
      this.socket = new WebSocket(this.environment.socket);
      //this.socket.binaryType = "arraybuffer";
      this.socket.onopen = function(e) {
        console.log("已连接至服务器");
      };
      this.socket.onclose = function(e) {
        console.log("链接已关闭");
      };
      this.socket.onmessage = e => {
        //输出日志
        if (
          !e.data.includes("createXcXpEnd") &&
          !e.data.includes("createUserEnd") &&
          !e.data.includes("createSpecEnd") &&
          !e.data.includes("start") &&
          !e.data.includes("end")
        ) {
          this.logMessageArr.push(e.data);
          const dom = document.querySelector("#strategy");
          this.$nextTick(() => {
            dom.scrollTop = dom.scrollHeight;
          });
          console.log(e, 1111);
        }
        this.logMessage.push(e.data);
        //发起策略日志
        this.StrategyLog();
        //获取结束标识
        this.createxkMallProjectLog(e.data);
        this.initializePhoneLog(e.data);
        this.createSizeLog(e.data);
      };
      this.socket.onerror = function(e) {
        console.log("出现错误");
      };
    },
    //创建芯城芯品日志结束
    createxkMallProjectLog(val) {
      let data = [];
      data.push(val);
      const endCondition = data.filter(v => v.includes("createXcXpEnd"));
      if (endCondition.length != 0) {
        this.btnDisabled = false;
        this.message();
      }
    },
    //初始化手机号上下级日志结束
    initializePhoneLog(val) {
      let data = [];
      data.push(val);
      const endCondition = data.filter(v => v.includes("createUserEnd"));
      if (endCondition.length != 0) {
        this.btnDisabled = false;
        this.message();
      }
    },
    //创建规格日志结束
    createSizeLog(val) {
      let data = [];
      data.push(val);
      const endCondition = data.filter(v => v.includes("createSpecEnd"));
      if (endCondition.length != 0) {
        this.btnDisabled = false;
        this.message();
      }
      const warning = data.filter(v => v.includes("系统出现异常"));
      if (warning.length != 0) {
        this.btnDisabled = false;
        this.message();
      }
    },
    //发起策略日志
    StrategyLog() {
      //获取key值
      const keyArr = this.logMessage.filter(v => v.includes("start"));
      if (keyArr.length != 0) {
        this.key = keyArr[0].slice(keyArr[0].length - 13, keyArr[0].length);
      }
      //获取结束状态标识
      const endCondition = this.logMessage.filter(v => v.includes("end"));
      if (endCondition.length != 0) {
        this.btnDisabled = false;
        let logData = {
          code: 5,
          data: { key: this.key, logs: [] }
        };
        logData.data.logs = this.logMessage;
        this.socket.send(JSON.stringify(logData));
        this.message();
        //每次策略结束清空日志
        setTimeout(() => {
          this.logMessage = [];
        }, 2000);
      }
    },
    message() {
      this.$message({
        type: "success",
        duration: 0,
        showClose: true,
        message: "当前操作已结束!"
      });
      this.time = 180;
    },
    //按钮恢复倒计时
    buttonActive() {
      clearInterval(this.timeOut);
      this.timeOut = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timeOut);
          this.time = 180;
          this.btnDisabled = false;
        }
      }, 1000);
    },
    handleClose(data) {
      this.dialogVisible = data;
    },
    saveCase() {
      const { sizeData, initUser } = this.setData()
    
       const data =  JSON.stringify({
          createXinCheng: this.xinChengs,
          remark: this.remark,
          sizeData: sizeData,
          initUser: initUser
        })
        console.log(data, 100000)
      saveExample({data,}, this.environment.http).then(res => {
        if(res.code == 200) {
          this.$message.success('保存成功!')
        }
      })
    },
    echoData({ createXcXpData, sizeData, regData }) {
      this.xinChengs = createXcXpData;
      this.sizeData = sizeData;
      this.regData = regData;
    },
  }
};
</script>
<style scoped lang="scss">
.comm_strategy {
  width: 100%;
  height: 100%;
  padding: 20px 30px;
  font-size: 14px;
  .strategy_tab_create {
    width: 100%;
    .el_input {
      text-align: center;
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: 10px;
      height: 40px;
      line-height: 40px;
      outline: 0;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .create_item {
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .strategy_create {
      width: 100%;
      margin-bottom: 20px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 10px;
      .strategy_create_header {
        margin-bottom: 10px;
      }
      .strategy_create_body {
        .create_body_item {
          margin-bottom: 15px;
        }
        .scroll_body_item {
          display: flex;
          .scroll_col {
            flex-shrink: 0;
            margin: 0 8px;
          }
        }
      }
      .strategy_log_body {
        display: flex;
        justify-content: center;
        padding-right: 60px;
        .strategy_log {
          width: 100%;
          height: 300px;
          border: 1px solid #ddd;
          padding: 0 10px;
          overflow: auto;
        }
      }
    }
    .scroll_strategy_create {
      overflow: auto;
      .scroll-header {
        width: 100%;
        display: flex;
        span {
          flex-shrink: 0;
          margin: 0 8px;
        }
      }
    }
  }
  .strategy_tab_result {
    width: 100%;
  }
  .hover_style {
    cursor: pointer;
  }
  input::-webkit-input-placeholder {
    color: #eee;
  }
}
.comm_strategy /deep/ .el-input input::-webkit-input-placeholder {
  color: #eee;
}
</style>
